export const SEND_COLLECTOR_EVENT_QUERY_KEY = ['collector', 'api', 'event'];
export const SEND_COLLECTOR_EVENT_REQUEST_PATHNAME = '/event';

export const ANALYTIC_DEFAULT_CLUSTER = 14;
export const ANALYTIC_DEFAULT_NETWORK = 14;
export const ANALYTIC_EVENT_SOURCE = 5;
